// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__1PpcV","label":"Completed_label__1NAIr"};